import { Outlet } from '@remix-run/react'
import { MarketingNav } from '#app/components/marketing/MarketingNav'
import { MarketingFooter } from '#app/components/marketing/MarketingFooter'

export const ROUTE_PATH = '/' as const

export async function loader() {
  return {}
}

export default function Home() {
  return (
    <div className="relative flex min-h-screen w-full flex-col bg-card">
      <MarketingNav />
      <Outlet />
      <MarketingFooter />
    </div>
  )
}
